import http from '../http'

export const BackendApiService = {
  upload,
  getItems,
  getRefs,
  getRefsByName,
  deleteItem,
  deleteRef,
  saveItem,
  saveRef,
  getSchemas,
  getSchema,
  deleteSchema,
  updateSchema,
  deleteData,
  deleteAdminData,
  uploadData,
  getExport,
  getAdminExport,
  generateAdminExcelData,
  generateExcelData,
  changePassword,
  readVersion,
  generateId,
  startDmixSync
}

function upload (file, onUploadProgress) {
  let formData = new FormData()

  formData.append('file', file)

  return http.post('/api/uploadSchema', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}

function getItems (schemaId, params, userId) {
  return http.get('/api/items/' + schemaId + '/' + userId, { params })
}

function deleteItem (schemaId, itemId) {
  return http.get('/api/deleteItem/' + schemaId + '/' + itemId)
}

function deleteRef (refId) {
  return http.get('/api/deleteRef/' + refId)
}

function getRefs (schemaId) {
  return http.get('/api/refs/' + schemaId)
}

function getRefsByName (schemaId, refName, params) {
  return http.get('/api/refs/' + schemaId + '/' + refName, { params })
}

function saveItem (schemaId, itemId, itemProps) {
  return http.post('/api/saveItem/' + schemaId + '/' + itemId, itemProps, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }})
}

function saveRef (schemaId, refName, refId, itemProps) {
  return http.post('/api/saveRef/' + schemaId + '/' + refName + '/' + refId, itemProps, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }})
}

function getSchemas () {
  return http.get('/api/schemas').catch(err => {
    // what now?
    console.log(err)
    window.location.href = '/#/login'
  })
}

function getSchema (schemaId) {
  return http.get('/api/schema/' + schemaId)
}

function deleteSchema (schemaId) {
  return http.delete('/api/schema/' + schemaId)
}

function deleteData (schemaId) {
  return http.get('/api/deleteData/' + schemaId)
}

function deleteAdminData (schemaId) {
  return http.get('/api/deleteAdminData/' + schemaId)
}

function generateId (schemaId) {
  return http.get('/api/generateId/' + schemaId)
}

function uploadData (schemaId, file, onUploadProgress) {
  let formData = new FormData()
  console.log('Uploading Excel Data....')
  formData.append('file', file)

  return http.post('/api/uploadData/' + schemaId, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}
function updateSchema (file, changeTable, onUploadProgress) {
  let formData = new FormData()
  console.log('Uploading Schema Data....')
  formData.append('file', file)
  formData.append('changeTable', changeTable)

  return http.post('/api/updateSchema', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
}

function generateAdminExcelData (schemaId) {
  return http.get('/api/generateAdminExcelData/' + schemaId)
}

function generateExcelData (schemaId) {
  return http.get('/api/generateExcelData/' + schemaId)
}

function getExport (schemaId) {
  return http.get('/api/excelExport/' + schemaId)
}

function getAdminExport (schemaId) {
  return http.get('/api/excelAdminExport/' + schemaId)
}

function changePassword (oldPassword, newPassword) {
  return http.get('/api/changePassword/' + oldPassword + '/' + newPassword)
    .catch(function (error) {
      console.log('error catched')
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
    })
}

function readVersion () {
  return http.get('api/getVersion')
}

function startDmixSync (schemaId) {
  return http.get('api/doDmixSync/' + schemaId)
}



// WEBPACK FOOTER //
// ./src/services/BackendApiService.js